'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _getColoring = require('conversations-schema/operators/widget-data/getColoring');

var _gdprExplicitConsentRequired = require('conversations-schema/operators/widget-data/gdprExplicitConsentRequired');

var _gdprConsentToProcessEnabled = require('conversations-schema/operators/widget-data/gdprConsentToProcessEnabled');

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var _MessageEditor = require('./MessageEditor');

var _MessageEditor2 = _interopRequireDefault(_MessageEditor);

var _ConsentPrompt = require('./ConsentPrompt');

var _ConsentPrompt2 = _interopRequireDefault(_ConsentPrompt);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatAreaFooter = function (_React$Component) {
  _inherits(ChatAreaFooter, _React$Component);

  function ChatAreaFooter() {
    _classCallCheck(this, ChatAreaFooter);

    return _possibleConstructorReturn(this, (ChatAreaFooter.__proto__ || Object.getPrototypeOf(ChatAreaFooter)).apply(this, arguments));
  }

  _createClass(ChatAreaFooter, [{
    key: 'showGdprConsentToProcessButton',
    value: function showGdprConsentToProcessButton() {
      var _props = this.props,
          widgetData = _props.widgetData,
          hasGivenConsentToProcess = _props.hasGivenConsentToProcess;


      return (0, _gdprConsentToProcessEnabled.gdprConsentToProcessEnabled)(widgetData) && !hasGivenConsentToProcess && (0, _gdprExplicitConsentRequired.gdprExplicitConsentRequired)(widgetData);
    }
  }, {
    key: 'renderGDPRConsentPrompt',
    value: function renderGDPRConsentPrompt() {
      var _props2 = this.props,
          widgetData = _props2.widgetData,
          hasGivenConsentToProcess = _props2.hasGivenConsentToProcess;
      var showingHsBranding = widgetData.showingHsBranding;


      var className = (0, _classNames2.default)('input-container', 'm-bottom-2', {
        'no-branding': !showingHsBranding
      });

      if (!(0, _gdprConsentToProcessEnabled.gdprConsentToProcessEnabled)(widgetData) || hasGivenConsentToProcess) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(_ConsentPrompt2.default, {
          showButton: this.showGdprConsentToProcessButton(),
          message: (0, _WidgetDataModel.getConsentToProcessMessage)(widgetData),
          onClick: this.props.consentToProcess
        })
      );
    }
  }, {
    key: 'renderMessageEditor',
    value: function renderMessageEditor() {
      if (this.showGdprConsentToProcessButton()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: this.props.editorClassName },
        _react2.default.createElement(_MessageEditor2.default, {
          chatInputChanged: this.props.chatInputChanged,
          coloring: (0, _getColoring.getColoring)(this.props.widgetData),
          disabled: this.props.disabled,
          mobile: this.props.mobile,
          networkOffline: this.props.networkOffline,
          onAttachmentButtonClick: this.props.onAttachmentButtonClick,
          onRemoveAttachment: this.props.onRemoveAttachment,
          onSelectAttachmentFiles: this.props.onSelectAttachmentFiles,
          publishMessage: this.props.publishMessage,
          showingHsBranding: this.props.showingHsBranding,
          stagedAttachments: this.props.stagedAttachments,
          supportsAttachments: this.props.supportsAttachments,
          maxAttachmentFileSize: this.props.maxAttachmentFileSize,
          hasUnansweredQuickReplyMessage: this.props.hasUnansweredQuickReplyMessage
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderGDPRConsentPrompt(),
        this.renderMessageEditor()
      );
    }
  }]);

  return ChatAreaFooter;
}(_react2.default.Component);

ChatAreaFooter.propTypes = {
  chatInputChanged: _react.PropTypes.func.isRequired,
  consentToProcess: _react.PropTypes.func,
  disabled: _react.PropTypes.bool.isRequired,
  editorClassName: _react.PropTypes.string,
  hasGivenConsentToProcess: _react.PropTypes.bool.isRequired,
  hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
  maxAttachmentFileSize: _react.PropTypes.number.isRequired,
  mobile: _react.PropTypes.bool,
  networkOffline: _react.PropTypes.bool.isRequired,
  onAttachmentButtonClick: _react.PropTypes.func,
  onRemoveAttachment: _react.PropTypes.func.isRequired,
  onSelectAttachmentFiles: _react.PropTypes.func.isRequired,
  publishMessage: _react.PropTypes.func.isRequired,
  showingHsBranding: _react.PropTypes.bool.isRequired,
  stagedAttachments: _react.PropTypes.instanceOf(_immutable.List),
  supportsAttachments: _react.PropTypes.bool.isRequired,
  widgetData: (0, _RecordPropType2.default)('WidgetData').isRequired
};

ChatAreaFooter.defaultProps = {
  onSelectAttachmentFiles: function onSelectAttachmentFiles() {},
  supportsAttachments: false
};

exports.default = ChatAreaFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ChatAreaFooter.js
// module id = 1152
// module chunks = 2 3